module.exports = __webpack_public_path__ + "static/media/img9.041b055a.jpeg";